import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { useRouter } from "expo-router";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { AnimatedSplashScreen } from "@/components/AnimatedSplashScreen";
import { Ionicons } from "@expo/vector-icons";
import LottieView from "lottie-react-native";

const INTRO_SEEN_KEY = "@staatsen_intro_seen";


export default function IntroScreen() {
  const router = useRouter();
  const [showSplash, setShowSplash] = useState(true);
  const [isReady, setIsReady] = useState(false);

  // Simulate app ready after 1 second
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  /**
   * Handle splash animation finish
   */
  const handleSplashFinish = () => {
    setShowSplash(false);
  };

  /**
   * Handle continue button press
   * Marks intro as seen and navigates to login
   */
  const handleContinue = async () => {
    try {
      await AsyncStorage.setItem(INTRO_SEEN_KEY, "true");
      router.replace("/(auth)/login");
    } catch (error) {
      console.error("Error saving intro state:", error);
      router.replace("/(auth)/login");
    }
  };

  return (
    <View className="flex-1 bg-white">
      {/* Welcome Screen (after splash) */}
      {!showSplash && (
        <View className="flex-1 items-center justify-center px-8">
          {/* Lottie Animation */}
          <View className="items-center mb-8">
            <LottieView
              source={require("@/assets/sunshine_intro.json")}
              autoPlay
              loop
              style={{
                width: 200,
                height: 200,
              }}
            />
          </View>

          {/* Welcome Content */}
          <View className="items-center mb-12">
            <Text className="text-4xl font-bold text-gray-900 text-center mb-4">
              Welkom bij de{"\n"}Staatsen Familie App
            </Text>
            <Text className="text-lg text-gray-600 text-center leading-relaxed">
              Speel samen, in teams of solo, deel momenten en beleef onvergetelijke weekenden
            </Text>
          </View>

          {/* Features Preview */}
          <View className="w-full mb-12 space-y-4">
            <View className="flex-row items-center">
              <View className="w-12 h-12 rounded-full bg-purple-100 items-center justify-center mr-4">
                <Ionicons name="game-controller" size={24} color="#7C3AED" />
              </View>
              <View className="flex-1">
                <Text className="text-lg font-semibold text-gray-900">Speel spelletjes</Text>
                <Text className="text-gray-600">Uitdagende games en quizzen</Text>
              </View>
            </View>

            <View className="flex-row items-center mt-4">
              <View className="w-12 h-12 rounded-full bg-purple-100 items-center justify-center mr-4">
                <Ionicons name="trophy" size={24} color="#7C3AED" />
              </View>
              <View className="flex-1">
                <Text className="text-lg font-semibold text-gray-900">Verzamel punten</Text>
                <Text className="text-gray-600">Tijdens familie weekenden</Text>
              </View>
            </View>

            <View className="flex-row items-center mt-4">
              <View className="w-12 h-12 rounded-full bg-purple-100 items-center justify-center mr-4">
                <Ionicons name="images" size={24} color="#7C3AED" />
              </View>
              <View className="flex-1">
                <Text className="text-lg font-semibold text-gray-900">Deze app is alleen voor de Staats Familie</Text>
                <Text className="text-gray-600">Je moet een familielid zijn en de toegangscode hebben om toegang te krijgen tot de app.</Text>
              </View>
            </View>
          </View>

          {/* Continue Button */}
          <TouchableOpacity
            onPress={handleContinue}
            className="w-full py-4 rounded-2xl items-center justify-center mb-6"
            style={{ backgroundColor: "#7C3AED" }}
            activeOpacity={0.8}
            accessibilityRole="button"
            accessibilityLabel="Aan de slag"
          >
            <View className="flex-row items-center">
              <Text className="text-white text-lg font-bold mr-2 ">
                Aan de slag
              </Text>
              <Ionicons name="arrow-forward" size={20} color="#FFFFFF" />
            </View>
          </TouchableOpacity>
        </View>
      )}

      {/* Animated Splash Screen (Opa & Oma) */}
      {showSplash && (
        <AnimatedSplashScreen
          onFinish={handleSplashFinish}
          isReady={isReady}
        />
      )}
    </View>
  );
}
